export enum ButtonType {
  Primary = 'primary',
  Warning = 'warn'
}
